import React from "react";
import { Badge } from "../ui/badge";
import { StatusBadgeClasses } from "../../utils/status-utils";

const StatusBadge = ({ status }) => {
    return (
        <Badge variant="outline" className={StatusBadgeClasses[status] || StatusBadgeClasses.Draft}>
            {status}
        </Badge>
    );
};

export default StatusBadge;
